import { Skeleton } from "components/ui/skeleton";

export default function UserCommunitiesSkeleton() {
  return (
    <div className="rounded-md border">
      <div>
        <Skeleton className="w-full object-cover h-[200px] rounded-t-md" />
        {/* Name */}
        <div className="p-2 space-y-1">
          <Skeleton className="w-full h-8" />
          <Skeleton className={`w-full h-8`} />
        </div>
      </div>

      {/* Follower Post Like */}
      <div className="grid grid-cols-3 text-center p-2">
        <div className="space-y-1">
          <Skeleton className="w-full h-8" />
          <Skeleton className="w-full h-8" />
        </div>
        <div className="space-y-1">
          <Skeleton className="w-full h-8" />
          <Skeleton className="w-full h-8" />
        </div>
        <div className="space-y-1">
          <Skeleton className="w-full h-8" />
          <Skeleton className="w-full h-8" />
        </div>
      </div>

      <div className="grid grid-cols-1 p-2">
        <Skeleton className="w-full h-8" />
      </div>
    </div>
  );
}
